import React, { useState, useRef } from 'react'
import { Modal, Button, Tooltip } from 'antd'
import './style.scss'

const AgreementDialog = (props) => {
  const { width = 'medium', title = '', onOk, visible, onCancel } = props
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false)
  const agreementContentRef = useRef(null)

  const checkScroll = () => {
    const container = agreementContentRef.current
    const containerHeight = container.scrollHeight - container.clientHeight
    const scrollPosition = container.scrollTop
    // Update the state property if scrolled to the bottom
    setHasScrolledToBottom(scrollPosition >= containerHeight - 3)
  }

  const accept = () => {
    setHasScrolledToBottom(false)
    if (onOk) {
      onOk()
    }
  }

  return (
    <Modal
      visible={visible}
      title={title}
      onCancel={onCancel}
      footer={[
        <div key="agreementText" style={{ marginBottom: '20px', fontWeight: 'bold' }}>
          我已充分阅读、理解并接受{title}的全部内容
        </div>,
        <Tooltip placement="top" title={ !hasScrolledToBottom ? '请将滚动条滑动至本协议底部，以确保您已阅读并理解所有条款。' : `我已充分阅读、理解并接受${title}的全部内容`}>
          <Button
            key="acceptButton"
            type="primary"
            onClick={accept}
            disabled={!hasScrolledToBottom}
          >
          接受
          </Button>
        </Tooltip>
      ]}
      width={width}
      className="agreement-custom-class"
      centered
      destroyOnClose={true}
      maskClosable={false}
      onOk={accept}
    >
      <div className="agreement-inner" ref={agreementContentRef} onScroll={checkScroll}>
        {props.children}
      </div>
    </Modal>
  )
}

export default AgreementDialog
